import { Action, combineReducers } from "redux";
import { Action as ReduxAction, handleActions, ReducerMap } from "redux-actions";
import { IAction } from "reduxsauce";

import { Types as AllTypes } from "../../actions";
import { IClass } from "../types/common";
import { Action as ActionType } from "./actions";

export interface IState {
  _: IClassesState;
}

export interface IClassesState {
  classes: IClass[] | null;
  fetchAllClassesRequestState: RequestState;
  fetchAllClassesRequestError: string | null;
  addNewClassRequestState: RequestState;
  deleteClassRequestState: RequestState;
  deleteClassRequestError: string | null;
}

export enum RequestState {
  IDLE = "IDLE",
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
}

const Types = (AllTypes as any)._APP._CLASSES;

export const INITIAL_STATE: IClassesState = {
  addNewClassRequestState: RequestState.IDLE,
  classes: null,
  deleteClassRequestError: null,
  deleteClassRequestState: RequestState.IDLE,
  fetchAllClassesRequestError: null,
  fetchAllClassesRequestState: RequestState.IDLE,
};

export function mount(state: IClassesState, action: IAction): IClassesState {
  return INITIAL_STATE;
}

export function unmount(state: IClassesState, action: IAction): IClassesState {
  return INITIAL_STATE;
}

export function fetchAllClasses(state: IClassesState, action: ReduxAction<void>): IClassesState {
  return {
    ...state,
    fetchAllClassesRequestError: null,
    fetchAllClassesRequestState: RequestState.PENDING,
  };
}

export function handleFetchAllClassesFailure(
  state: IClassesState,
  action: ReduxAction<{ message: string }>
): IClassesState {
  return {
    ...state,
    fetchAllClassesRequestError: action.payload.message,
    fetchAllClassesRequestState: RequestState.FAILED,
  };
}

export function handleFetchAllClassesSuccess(state: IClassesState, action: ReduxAction<IClass[]>): IClassesState {
  return {
    ...state,
    classes: action.payload,
    fetchAllClassesRequestError: null,
    fetchAllClassesRequestState: RequestState.SUCCEEDED,
  };
}

export const deleteClass = (state: IClassesState, _: IAction): IClassesState => ({
  ...state,
  deleteClassRequestError: null,
  deleteClassRequestState: RequestState.PENDING,
});

export const handleDeleteClassFailure = (state: IClassesState, action: IAction): IClassesState => ({
  ...state,
  deleteClassRequestError: action.error.message,
  deleteClassRequestState: RequestState.FAILED,
});

export const handleDeleteClassSuccess = (state: IClassesState, action: IAction): IClassesState => ({
  ...state,
  classes: action.classes,
  deleteClassRequestError: null,
  deleteClassRequestState: RequestState.SUCCEEDED,
});

const addNewClass = (state: IClassesState) => ({
  ...state,
  addNewClassRequestState: RequestState.PENDING,
});

const handleAddNewClassSuccess = (state: IClassesState) => ({
  ...state,
  addNewClassRequestState: RequestState.SUCCEEDED,
});

const handleAddNewClassFailure = (state: IClassesState) => ({
  ...state,
  addNewClassRequestState: RequestState.FAILED,
});

const reduxsauceReducers: ReducerMap<IClassesState, any> = {
  [Types.MOUNT]: mount,
  [Types.DELETE_CLASS]: deleteClass,
  [Types.HANDLE_DELETE_CLASS_FAILURE]: handleDeleteClassFailure,
  [Types.HANDLE_DELETE_CLASS_SUCCESS]: handleDeleteClassSuccess,
  [Types.FETCH_ALL_CLASSES]: fetchAllClasses,
  [Types.HANDLE_FETCH_ALL_CLASSES_FAILURE]: handleFetchAllClassesFailure,
  [Types.HANDLE_FETCH_ALL_CLASSES_SUCCESS]: handleFetchAllClassesSuccess,
  [Types.UNMOUNT]: unmount,
};

type IClassesPayload = IClass[] | { message: string } | void;

const reuduxactionsReducers: ReducerMap<IClassesState, IClassesPayload> = {
  [ActionType.ADD_NEW_CLASS]: addNewClass,
  [ActionType.HANDLE_ADD_NEW_CLASS_FAILURE]: handleAddNewClassFailure,
  [ActionType.HANDLE_ADD_NEW_CLASS_SUCCESS]: handleAddNewClassSuccess,
  [ActionType.FETCH_ALL_CLASSES]: fetchAllClasses,
  [ActionType.HANDLE_FETCH_ALL_CLASSES_FAILURE]: handleFetchAllClassesFailure,
  [ActionType.HANDLE_FETCH_ALL_CLASSES_SUCCESS]: handleFetchAllClassesSuccess,
};

export default combineReducers<IState, Action>({
  _: handleActions<IClassesState, IClassesPayload>(
    {
      ...reuduxactionsReducers,
      ...reduxsauceReducers,
    },
    INITIAL_STATE
  ),
});
